module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-card', {
    staticClass: "bordered-card",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n        Add New Tutorial\n      ")])], 1), _vm._v(" "), _c('v-card-text', {}, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tutorial.question),
      expression: "tutorial.question"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Question here"
    },
    domProps: {
      "value": (_vm.tutorial.question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tutorial, "question", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('vue-editor', {
    attrs: {
      "placeholder": "Enter Answer here",
      "editorToolbar": _vm.customToolbar
    },
    model: {
      value: (_vm.tutorial.answer),
      callback: function($$v) {
        _vm.$set(_vm.tutorial, "answer", $$v)
      },
      expression: "tutorial.answer"
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticStyle: {
      "margin-top": "18px",
      "font-size": "18px",
      "display": "block"
    }
  }, [_vm._v("Media Type")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.mediaType),
      callback: function($$v) {
        _vm.mediaType = $$v
      },
      expression: "mediaType"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Image",
      "value": "image"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Video",
      "value": "video"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "No Media",
      "value": ""
    }
  })], 1)], 1), _vm._v(" "), (_vm.mediaType === 'image') ? _c('v-card', {
    staticClass: "bordered-card mt-3"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4",
    attrs: {
      "dense": ""
    }
  }, [_vm._v("\n                Featured Image ("), _c('strong', [_vm._v("Recommendation: No larger than 500 * 300")]), _vm._v(")\n              ")])], 1), _vm._v(" "), _c('v-card-text', [(_vm.tutorialPhotoFile !== '') ? _c('v-card', {
    staticClass: "mt-0 pt-0"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "id": "close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelResourcePhoto()
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.tutorialPhotoFileURL,
      "id": "faqActivity"
    }
  })], 1)]) : _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.tutorialPhotoUploaded = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("insert_photo")]), _vm._v("\n                Add Media\n              ")], 1), _vm._v(" "), _c('file-upload', {
    attrs: {
      "trigger": _vm.tutorialPhotoUploaded,
      "formats": ['jpeg', 'png', 'jpg']
    },
    on: {
      "cancel": function($event) {
        _vm.tutorialPhotoUploaded = false;
        _vm.tutorialPhotoFile = ''
      },
      "confirm": function($event) {
        return _vm.showTutorialPhoto()
      }
    },
    model: {
      value: (_vm.tutorialPhotoFile),
      callback: function($$v) {
        _vm.tutorialPhotoFile = $$v
      },
      expression: "tutorialPhotoFile"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.mediaType === 'video') ? _c('v-card', {
    staticClass: "bordered-card mt-3"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4",
    attrs: {
      "dense": ""
    }
  }, [_vm._v("\n                Featured Video\n              ")])], 1), _vm._v(" "), _c('v-card-text', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.videoLink),
      expression: "videoLink"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Video link e.g youtube or vimeo"
    },
    domProps: {
      "value": (_vm.videoLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.videoLink = $event.target.value
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-btn', {
    staticClass: "primary",
    staticStyle: {
      "margin": "10px 0px"
    },
    attrs: {
      "disabled": this.$store.getters.getLoading && _vm.tutorialProcess,
      "loading": this.$store.getters.getLoading && _vm.tutorialProcess
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addResource()
      }
    }
  }, [_vm._v("\n              Save\n              "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("cached")])], 1)]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    staticStyle: {
      "margin": "10px 10px"
    },
    attrs: {
      "disabled": this.$store.getters.getLoading && _vm.tutorialProcess
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goBack.apply(null, arguments)
      }
    }
  }, [_vm._v("\n              Cancel\n            ")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-695d3f94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Tutorial/NewTutorial.vue
// module id = 1697
// module chunks = 5